import { alpha } from "@material-ui/core/styles";

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// SETUP COLORS
const GREY = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
  500_8: alpha("#919EAB", 0.08),
  500_12: alpha("#919EAB", 0.12),
  500_16: alpha("#919EAB", 0.16),
  500_24: alpha("#919EAB", 0.24),
  500_32: alpha("#919EAB", 0.32),
  500_48: alpha("#919EAB", 0.48),
  500_56: alpha("#919EAB", 0.56),
  500_80: alpha("#919EAB", 0.8),
};

const PRIMARY = {
  lighter: "#B0CAEE",
  light: "#6195DD",
  main: "#1260CC",
  dark: "#0C4088",
  darker: "#062044",
  contrastText: "#fff",
};
const SECONDARY = {
  lighter: "#B7F8F8",
  light: "#70F1F0",
  main: "#28EAE9",
  dark: "#1B9C9B",
  darker: "#0D4E4E",
  contrastText: "#fff",
};
const INFO = {
  lighter: "#CCEDFD",
  light: "#98DBFC",
  main: "#65C9FA",
  dark: "#4386A7",
  darker: "#224353",
  contrastText: "#fff",
};
const SUCCESS = {
  lighter: "#C6FCC2",
  light: "#8CF886",
  main: "#53F549",
  dark: "#37A331",
  darker: "#1C5218",
  contrastText: GREY[800],
};
const WARNING = {
  lighter: "#F5E1BA",
  light: "#EBC375",
  main: "#E1A530",
  dark: "#966E20",
  darker: "#4B3710",
  contrastText: GREY[800],
};
const ERROR = {
  lighter: "#F3BCC1",
  light: "#E87883",
  main: "#DC3545",
  dark: "#93232E",
  darker: "#491217",
  contrastText: "#fff",
};
const DISABLED = {
  lighter: "#DFE2E3",
  light: "#C0C4C8",
  main: "#A0A7AC",
  dark: "#6B6F73",
  darker: "#353839",
  contrastText: "#fff",
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main),
};

const COMMON = {
  common: { black: "#000", white: "#fff" },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  disabled: { ...DISABLED },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,
  gradients: GRADIENTS,
  divider: GREY[500_24],
  action: {
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

const palette = {
  light: {
    ...COMMON,
    text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
    background: { paper: "#fff", default: "#fff", neutral: GREY[200] },
    action: { active: GREY[600], ...COMMON.action },
  },
  dark: {
    ...COMMON,
    text: { primary: "#fff", secondary: GREY[500], disabled: GREY[600] },
    background: { paper: GREY[800], default: GREY[900], neutral: GREY[500_16] },
    action: { active: GREY[500], ...COMMON.action },
  },
};

export default palette;
